import * as React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';

import { cn } from '@cotera/client/v0/lib/utils';

type SeparatorProps = React.ComponentProps<typeof SeparatorPrimitive.Root> & {
  children?: React.ReactNode;
  caption?: string;
};

function Separator({
  className,
  orientation = 'horizontal',
  decorative = true,
  children,
  caption,
  ...props
}: SeparatorProps) {
  const content = children ?? caption;

  // If there's content (caption or children), render with separator lines on both sides
  if (content != null) {
    return (
      <div
        className={cn(
          'flex flex-row items-center',
          orientation === 'vertical' && 'flex-col',
          className
        )}
      >
        <SeparatorPrimitive.Root
          data-slot="separator"
          decorative={decorative}
          orientation={orientation}
          className={cn(
            'bg-border shrink-0',
            orientation === 'horizontal' ? 'h-px flex-1' : 'w-px flex-1'
          )}
          {...props}
        />
        <span
          className={cn(
            'shrink-0',
            orientation === 'horizontal' ? 'mx-4' : 'my-4'
          )}
        >
          {content}
        </span>
        <SeparatorPrimitive.Root
          data-slot="separator"
          decorative={decorative}
          orientation={orientation}
          className={cn(
            'bg-border shrink-0',
            orientation === 'horizontal' ? 'h-px flex-1' : 'w-px flex-1'
          )}
          {...props}
        />
      </div>
    );
  }

  // Default: simple separator without caption
  return (
    <SeparatorPrimitive.Root
      data-slot="separator"
      decorative={decorative}
      orientation={orientation}
      className={cn(
        'bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px',
        className
      )}
      {...props}
    />
  );
}

export { Separator };
